"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  href?: string; // Custom href that overrides slug-based URL
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export const VerticalMediumImageHeadingNews = t0 => {
  const $ = _c(23);
  const {
    title: t1,
    imageSrc: t2,
    slug,
    href,
    priority: t3,
    imageMetadata
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "'\u0B8E\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9C\u0BA4\u0B95\u0BCD\u0B95\u0BC0\u0B9F\u0BC1 \u0B95\u0BCA\u0BB3\u0BCD\u0B95\u0BC8 \u0B95\u0BBE\u0B99\u0BCD\u0B95\u0BBF\u0BB0\u0BB8\u0BCD...",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const title = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const imageSrc = t5;
  const priority = t3 === undefined ? false : t3;
  const titleValue = title?.value || "";
  let t6;
  if ($[4] !== imageSrc?.value) {
    t6 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const imageSrcValue = t6;
  let t7;
  if ($[6] !== imageMetadata || $[7] !== imageSrc?.customClass || $[8] !== imageSrc?.hidden || $[9] !== imageSrcValue || $[10] !== priority || $[11] !== titleValue) {
    t7 = !imageSrc?.hidden && <div><div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[6] = imageMetadata;
    $[7] = imageSrc?.customClass;
    $[8] = imageSrc?.hidden;
    $[9] = imageSrcValue;
    $[10] = priority;
    $[11] = titleValue;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== title?.customClass || $[14] !== title?.hidden || $[15] !== titleValue) {
    t8 = !title?.hidden && <h3 className={`text-14-tamil-700 leading-[1.2] text-1B1B1B ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[13] = title?.customClass;
    $[14] = title?.hidden;
    $[15] = titleValue;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-col overflow-hidden p-4 gap-4">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const content = t9;
  const linkHref = href || (slug ? `/${slug}` : null);
  if (linkHref) {
    let t10;
    if ($[20] !== content || $[21] !== linkHref) {
      t10 = <Link href={linkHref} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[20] = content;
      $[21] = linkHref;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    return t10;
  }
  return content;
};